module.exports = "<div ng-if=\"$ctrl.storageOptions\" \n     class=\"gridStorageStyle\" \n     ui-grid-edit \n     ui-grid-row-edit\n     ui-grid-selection\n     ui-grid=\"$ctrl.storageOptions\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/storage-dashboard/storage-dashboard.html
// module id = 96
// module chunks = 0